export const FrenchRoutes = {
  Home: {
    URL: 'fr',
  },
  Register: {
    URL: 'fr/enregistrement',
  },
  RegisterWithPromotion: {
    URL: 'fr/enregistrement/:promotion',
  },
  Login: {
    URL: 'fr/login',
  },
  Contact: {
    URL: 'fr/contact',
  },
  TermsOfUse: {
    URL: 'fr/terms',
  },
  Cookies: {
    URL: 'fr/cookies',
  },
  Privacy: {
    URL: 'fr/privacy',
  },
  Hiring: {
    URL: 'fr/contract',
  },
  HiringWithRate: {
    URL: 'fr/contract/:rate',
  },
  'android-login': {
    URL: 'fr/android-login',
  },
  'android-register': {
    URL: 'fr/android-register',
  },
  Platform: {
    URL: 'plate-forme',
  },
};
